import React from "react"

export const QuestionmarkIcon = ({
  size = 1,
  color = "#034055",
  strokeWidth = "2.5",
  className = undefined,
}) => {
  return (
    <svg
      className={className}
      width={26 * size}
      height={26 * size}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <circle
          stroke={color}
          strokeWidth={strokeWidth}
          cx="13"
          cy="13"
          r="11.846"
        />
        <path
          d="m13.536 14.464.209-1.195a.907.907 0 0 1 .263-.472c.142-.142.31-.285.506-.43.195-.145.4-.301.618-.468.217-.167.416-.365.598-.594.18-.228.331-.497.45-.806.12-.31.18-.676.18-1.1 0-.44-.079-.838-.238-1.194a2.613 2.613 0 0 0-.672-.915 3.028 3.028 0 0 0-1.045-.585 4.265 4.265 0 0 0-1.362-.205c-.362 0-.7.032-1.016.096a4.818 4.818 0 0 0-.877.263 4.57 4.57 0 0 0-.752.393c-.232.15-.447.312-.648.485l.61.953a.516.516 0 0 0 .476.275.568.568 0 0 0 .301-.1c.106-.067.234-.14.385-.221.15-.081.33-.155.539-.222.209-.067.466-.1.773-.1.418 0 .753.109 1.007.326.253.217.38.51.38.877 0 .301-.065.562-.196.782a2.6 2.6 0 0 1-.485.593 6 6 0 0 1-.618.493c-.22.153-.42.312-.598.476-.178.165-.32.346-.426.544-.106.197-.14.43-.1.697l.158 1.354h1.58zm-.861 4.413c.19 0 .368-.034.535-.1a1.31 1.31 0 0 0 .723-.702c.07-.162.104-.337.104-.527a1.325 1.325 0 0 0-.827-1.233 1.377 1.377 0 0 0-.535-.104 1.368 1.368 0 0 0-.97.389 1.325 1.325 0 0 0-.393.949 1.316 1.316 0 0 0 .394.948c.122.12.266.213.43.28.164.066.344.1.539.1z"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
